import React from "react";
import { connect } from "react-redux";
import language from "../../language";
import { Table } from "../Table";
import { CSVLink } from "react-csv";
import donorsQuery, {
  deleteDonors,
  getDonorDashboardCounts,
} from "../../utils/queries/donorsQuery";
import NewDonor from "./NewDonor";
import { DeleteModal, Modal } from "../Modal";
import { getStorage } from "../../utils/storage";
import icons from "../../constants/icons";
import { Tabs } from "../Tabs";
import PreAssessment from "./Pre-assessment/Answers/Index";
import BloodCollection from "../BloodCollection/BloodCollection";
import {
  defineRole,
  defineRoleCenterSite,
} from "../../utils/handleAccessRoles";
import Block from "./Block";
import UnBlock from "./UnBlock";
import { ROLE_DONORS } from "../../constants/ROLES";
import DonorFilters from "../Filters/donor/DonorFilters";
import { CentersFilter, CenterSitesFilter, DateFilter } from "../Filters";
import handleFilters from "../../utils/handleFilters";
import moment from "moment";
import CardCount from "../CardCount/CardCount";

class Donors extends React.Component {
  csvDownload = React.createRef();

  state = {
    isLoading: false,
    data: [],
    page: 1,
    limit: 10,
    search_text: "",
    selectedData: {},
    delete_value: "",
    error: {},
    csvData: [],
    user: {},
    filters: {
      startDate: moment().subtract(1, "month").format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    },
    isLoadingCounts: false,
    totalRecords: 0,
    totalPages: 0,
    counts: {
      newDonor: 0,
      repeatDonor: 0,
      totalDonors: 0,
      noDocument: 0,
    },
    showCountDetailsModal: false,
    countDetailsType: "",
    countDetailsTitle: "",
    isLoadingCountDetails: false,
    countDetailsData: [],
    countDetailsPage: 1,
    countDetailsLimit: 10,
    countDetailsTotalRecords: 0,
    countDetailsTotalPageCount: 0,
    countDetailsSearchText: "",
    searchingCountDetails: false,
  };

  componentDidMount = async () => {
    const user = await getStorage();
    await this.setState({ user });

    await this.fetchData(true);
  };

  onChangeText(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({
      [field]: e?.target?.value,
      error,
    });
  }

  fetchData = async (isLoading, search = {}) => {
    const nextFilters = {
      ...this.state.filters,
      ...search,
    };

    const hasFilterUpdate = Object.keys(search || {}).length > 0;

    this.setState(
      {
        filters: nextFilters,
        ...(hasFilterUpdate ? { page: 1 } : {}),
      },
      () => this.getData(isLoading),
    );
  };

  returnFilters = async () => {
    const { page, limit } = this.state;
    let { centerId, siteId } = this.props;
    const activeFilters = this.state.filters || {};
    const { centers, centerSites, ...plainFilters } = activeFilters;

    const roleScope = (await defineRoleCenterSite()) || {};
    const { centerRole, centerSiteRole } = roleScope;

    const normalizedFilters = handleFilters({ ...activeFilters });

    return {
      page,
      limit,
      center: centerId || centerRole,
      centerSite: siteId || centerSiteRole,
      ...plainFilters,
      ...normalizedFilters,
      ...this.props.filters,
    };
  };

  getData = async (isLoading) => {
    try {
      let { defaultLanguage } = this.props;

      this.setState({ isLoading, isLoadingCounts: isLoading });

      const params = await this.returnFilters();

      const [donorResponse, dashboardCounts] = await Promise.all([
        donorsQuery(defaultLanguage, params),
        getDonorDashboardCounts(defaultLanguage, params),
      ]);
      const data = donorResponse?.data || [];

      const totalRecords = dashboardCounts?.totalDonors || 0;
      const totalPages = Math.ceil(totalRecords / this.state.limit);

      this.setState({
        data: data || [],
        counts: {
          totalDonors: dashboardCounts?.totalDonors || 0,
          newDonor: dashboardCounts?.newDonor || 0,
          repeatDonor: dashboardCounts?.repeatDonor || 0,
          noDocument: dashboardCounts?.noDocument || 0,
        },
        totalRecords,
        totalPages,
        totalPageCount: totalPages,
        isLoading: false,
        isLoadingCounts: false,
      });
    } catch (error) {
      console.log(error);
      this.setState({
        isLoading: false,
        isLoadingCounts: false,
      });
    }
  };

  handlePagination(page) {
    this.setState({ page }, () => {
      this.getData(true);
    });
  }

  handleLimitChange = (newLimit) => {
    this.setState({ limit: newLimit, page: 1 }, () => {
      this.getData(true);
    });
  };

  handleShowModal(modal, modalTitle, selectedData = {}) {
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      selectedData,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].photo,
        key: "imageUrl",
        type: "photo",
      },
      {
        title: language[this.props.defaultLanguage].donor_number,
        key: "donorNumber",
        type: "link",
        onPress: (item) =>
          (window.location.href = `/dashboard/donors/${item._id}/${item.firstName} ${item.lastName}`),
        styles: {
          textTransform: "uppercase",
        },
        copyEnabled: true,
      },
      {
        title: language[this.props.defaultLanguage].category,
        key: "category",
      },
      {
        title: language[this.props.defaultLanguage].first_name,
        key: "firstName",
      },
      {
        title: language[this.props.defaultLanguage].last_name,
        key: "lastName",
      },
      {
        title: language[this.props.defaultLanguage].nationality,
        key: "nationality",
      },
      {
        title: language[this.props.defaultLanguage].identity_doc_type,
        key: "identityDocNumberType",
      },
      {
        title: language[this.props.defaultLanguage].identity_doc_number,
        key: "identityDocNumber",
      },
      {
        title: language[this.props.defaultLanguage].blood_group,
        key: "bloodGroup",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].email_address,
        key: "email",
        styles: {
          textTransform: "lowercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].phone_number,
        key: "phoneNumber",
      },
      {
        title: language[this.props.defaultLanguage].center,
        key: "center.name",
      },
      {
        title: language[this.props.defaultLanguage].center_site,
        key: "centerSite.name",
      },
      {
        title: language[this.props.defaultLanguage].place_of_birth,
        key: "placeOfBirth",
      },
      {
        title: language[this.props.defaultLanguage].created_at,
        key: "createdAt",
        isMoment: true,
        formatTime: "lll",
      },
      {
        title: language[this.props.defaultLanguage].actions,
        key: "action",
      },
    ];

    return headers;
  }

  downloadExcel = async () => {
    try {
      this.setState({
        isLoading: true,
      });

      const { page, limit } = this.state;
      const { defaultLanguage } = this.props;

      const { data } = await donorsQuery(defaultLanguage, {
        page,
        limit,
      });

      this.setState({
        isLoading: false,
        csvData: data,
      });

      this.csvDownload.current?.link.click();
    } catch (error) {
      this.setState({
        isLoading: false,
      });
    }
  };

  onDelete = async () => {
    try {
      this.setState({ isDeleting: true });

      await deleteDonors(
        this.props.defaultLanguage,
        this.state.selectedData._id,
      );

      this.setState({ isDeleting: false });

      this.getData(true);
      this.handleCloseModal("showDeleteModal");
    } catch (error) {
      this.setState({
        isDeleting: false,
      });
    }
  };

  handleSearchButton = async () => {
    const { search_text } = this.state;

    try {
      await this.fetchData(true, { donorNumber: search_text });
    } catch (error) {
      this.setState({
        isLoading: false,
        isLoadingCounts: false,
      });
    }
  };

  handleSearch = async (e) => {
    const search = e?.target?.value;
    this.setState({ search_text: search });
  };

  handleRemoteSearch = async (search) => {
    await new Promise((r) => this.setState({ searching: true, page: 1 }, r));

    await this.fetchData(true, {
      q: search !== "" ? search : undefined,
    });

    this.setState({
      searching: false,
    });
  };

  getCountDetailsFilter = (countType) => {
    if (countType === "newDonor") {
      return { category: "newDonor" };
    }

    if (countType === "repeatDonor") {
      return { category: "repeatDonor" };
    }

    if (countType === "noDocument") {
      return { identityDocNumberType: "noDocument" };
    }

    return {};
  };

  getCountDetailsTotal = (countType) => {
    if (countType === "newDonor") return this.state.counts.newDonor || 0;
    if (countType === "repeatDonor") return this.state.counts.repeatDonor || 0;
    if (countType === "noDocument") return this.state.counts.noDocument || 0;
    return this.state.counts.totalDonors || 0;
  };

  getCountDetailsData = async (
    isLoading = false,
    page = this.state.countDetailsPage,
    countType = this.state.countDetailsType,
    searchText = this.state.countDetailsSearchText,
  ) => {
    if (!countType) return;

    try {
      const { defaultLanguage } = this.props;
      const baseParams = await this.returnFilters();
      const filterByCountType = this.getCountDetailsFilter(countType);
      const trimmedSearchText = (searchText || "").trim();
      const hasSearch = trimmedSearchText !== "";
      const totalRecords = this.getCountDetailsTotal(countType);
      const limit = this.state.countDetailsLimit;

      this.setState({ isLoadingCountDetails: isLoading });

      const response = await donorsQuery(defaultLanguage, {
        ...baseParams,
        ...filterByCountType,
        page,
        limit,
        q: hasSearch ? trimmedSearchText : undefined,
      });
      const responseTotal = response?.count || 0;

      this.setState({
        countDetailsData: response?.data || [],
        countDetailsTotalRecords: hasSearch ? responseTotal : totalRecords,
        countDetailsTotalPageCount: Math.ceil(
          (hasSearch ? responseTotal : totalRecords) / limit,
        ),
        countDetailsPage: page,
        countDetailsType: countType,
        isLoadingCountDetails: false,
      });
    } catch (error) {
      this.setState({ isLoadingCountDetails: false });
    }
  };

  handleCountDetailsOpen = (countType, countTitle) => {
    const totalRecords = this.getCountDetailsTotal(countType);
    const limit = this.state.countDetailsLimit;

    this.setState(
      {
        showCountDetailsModal: true,
        countDetailsType: countType,
        countDetailsTitle: countTitle,
        countDetailsData: [],
        countDetailsPage: 1,
        countDetailsTotalRecords: totalRecords,
        countDetailsTotalPageCount: Math.ceil(totalRecords / limit),
        countDetailsSearchText: "",
        searchingCountDetails: false,
      },
      () => this.getCountDetailsData(true, 1, countType),
    );
  };

  handleCountDetailsClose = () => {
    this.setState({
      showCountDetailsModal: false,
      countDetailsType: "",
      countDetailsTitle: "",
      isLoadingCountDetails: false,
      countDetailsData: [],
      countDetailsPage: 1,
      countDetailsTotalRecords: 0,
      countDetailsTotalPageCount: 0,
      countDetailsSearchText: "",
      searchingCountDetails: false,
    });
  };

  handleCountDetailsPagination = (page) => {
    this.getCountDetailsData(true, page);
  };

  handleCountDetailsSearch = (e) => {
    this.setState({
      countDetailsSearchText: e?.target?.value || "",
    });
  };

  handleCountDetailsRemoteSearch = async () => {
    this.setState({
      searchingCountDetails: true,
    });

    await this.getCountDetailsData(
      true,
      1,
      this.state.countDetailsType,
      this.state.countDetailsSearchText,
    );

    this.setState({
      searchingCountDetails: false,
    });
  };

  returnCountDetailsHeaders = () => {
    const { defaultLanguage } = this.props;
    return [
      {
        title: language[defaultLanguage].donor_number,
        key: "donorNumber",
      },
      {
        title: language[defaultLanguage].category,
        key: "category",
      },
      {
        title: language[defaultLanguage].first_name,
        key: "firstName",
      },
      {
        title: language[defaultLanguage].last_name,
        key: "lastName",
      },
      {
        title: language[defaultLanguage].identity_doc_type,
        key: "identityDocNumberType",
      },
      {
        title: language[defaultLanguage].center,
        key: "center.name",
      },
      {
        title: language[defaultLanguage].center_site,
        key: "centerSite.name",
      },
      {
        title: language[defaultLanguage].created_at,
        key: "createdAt",
        isMoment: true,
        formatTime: "lll",
      },
    ];
  };

  render() {
    const { add_donor, donor, delete_, edit, view } =
      language[this.props.defaultLanguage];

    return (
      <>
        <div style={{ marginBottom: 16 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
            <CentersFilter
              handleApplyFilters={(isLoading, search) =>
                this.fetchData(isLoading, search)
              }
            />
            <CenterSitesFilter
              selectedCenters={this.state.filters.centers || []}
              handleApplyFilters={(isLoading, search) =>
                this.fetchData(isLoading, search)
              }
            />
            <DateFilter
              startDate={this.state.filters.startDate}
              endDate={this.state.filters.endDate}
              handleApplyFilters={(isLoading, search) =>
                this.fetchData(isLoading, search)
              }
            />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-md-3">
            <CardCount
              count={this.state.counts.totalDonors}
              title={language[this.props.defaultLanguage].total_donors}
              color="orange"
              icon="groups"
              isLoading={this.state.isLoadingCounts}
              onPress={() =>
                this.handleCountDetailsOpen(
                  "totalDonors",
                  language[this.props.defaultLanguage].total_donors,
                )
              }
            />
          </div>
          <div className="col-md-3">
            <CardCount
              count={this.state.counts.newDonor}
              title={language[this.props.defaultLanguage].new_donors}
              color="#078ECE"
              icon="group"
              isLoading={this.state.isLoadingCounts}
              onPress={() =>
                this.handleCountDetailsOpen(
                  "newDonor",
                  language[this.props.defaultLanguage].new_donors,
                )
              }
            />
          </div>
          <div className="col-md-3">
            <CardCount
              count={this.state.counts.repeatDonor}
              title={language[this.props.defaultLanguage].repeat_donors}
              color="gray"
              icon="undo"
              isLoading={this.state.isLoadingCounts}
              onPress={() =>
                this.handleCountDetailsOpen(
                  "repeatDonor",
                  language[this.props.defaultLanguage].repeat_donors,
                )
              }
            />
          </div>
          <div className="col-md-3">
            <CardCount
              count={this.state.counts.noDocument}
              title={
                language[this.props.defaultLanguage].donors_with_no_document
              }
              color="#800080"
              icon="label_off"
              isLoading={this.state.isLoadingCounts}
              onPress={() =>
                this.handleCountDetailsOpen(
                  "noDocument",
                  language[this.props.defaultLanguage].donors_with_no_document,
                )
              }
            />
          </div>
        </div>
        <Table
          data={this.state.data}
          isSearch
          page={this.state.page}
          limit={this.state.limit}
          search_text={this.state.search_text}
          handleSearch={this.handleSearch.bind(this)}
          addSearchButton
          searching={this.state.searching}
          handlePressSearch={() =>
            this.handleRemoteSearch(this.state.search_text)
          }
          totalPageCount={this.state.totalPageCount}
          totalRecords={this.state.totalRecords}
          isLoading={this.state.isLoading}
          handlePagination={this.handlePagination.bind(this)}
          onLimitChange={this.handleLimitChange}
          headers={this.returnTableHeaders()}
          showAdd={defineRole({
            roles: this.state.user.accessRole,
            menu: ROLE_DONORS,
            operation: "create",
          })}
          addButtonText={add_donor}
          handleAddPressed={this.handleShowModal.bind(this, "showModal", donor)}
          rowPress={(item) =>
            this.handleShowModal("showModal", item.name, item)
          }
          actions={[
            {
              canAccess: defineRole({
                roles: this.state.user.accessRole,
                menu: ROLE_DONORS,
                operation: "read",
              }),
              name: view,
              onPress: (item) =>
                (window.location.href = `/dashboard/donors/${item._id}/${item.firstName} ${item.lastName}`),

              icon: icons.eye_on,
            },
            {
              canAccess: defineRole({
                roles: this.state.user.accessRole,
                menu: ROLE_DONORS,
                operation: "update",
              }),
              name: edit,
              onPress: (item) =>
                this.handleShowModal("showModal", item.donorNumber, item),
              icon: icons.edit,
            },
            {
              canAccess: defineRole({
                roles: this.state.user.accessRole,
                menu: ROLE_DONORS,
                operation: "block",
              }),
              isHidden: (item) => !!item.blockInfo?.blocked,
              name: language[this.props.defaultLanguage].block,
              onPress: (item) =>
                this.handleShowModal(
                  "showBlockModal",
                  language[this.props.defaultLanguage].block +
                    " " +
                    item.donorNumber,
                  item,
                ),
              icon: icons.block,
            },
            {
              canAccess: defineRole({
                roles: this.state.user.accessRole,
                menu: ROLE_DONORS,
                operation: "unblock",
                pass: (this.state.user.accessRole || []).some((r) =>
                  r?.name?.toUpperCase()?.includes("SYSADMIN")
                ),
              }),
              isHidden: (item) => !item.blockInfo?.blocked,
              name: language[this.props.defaultLanguage].unblock,
              onPress: (item) =>
                this.handleShowModal(
                  "showUnblockModal",
                  language[this.props.defaultLanguage].unblock +
                    " " +
                    item.donorNumber,
                  item,
                ),
              icon: icons.success,
            },
            {
              canAccess: defineRole({
                roles: this.state.user.accessRole,
                menu: ROLE_DONORS,
                operation: "delete",
              }),
              name: delete_,
              onPress: (item) =>
                this.handleShowModal(
                  "showDeleteModal",
                  language[this.props.defaultLanguage].delete,
                  item,
                ),
              icon: icons.delete,
            },
          ]}
          filters={[
            {
              type: "button",
              title: language[this.props.defaultLanguage].refresh,
              button_type: "button",
              icon: icons.refresh,
              onPress: () => this.getData(true),
            },
            // {
            //   type: "button",
            //   title: language[this.props.defaultLanguage].filters,
            //   button_type: "button",
            //   icon: icons.filters,
            //   onPress: (item) =>
            //     this.handleShowModal(
            //       "filtersModal",
            //       language[this.props.defaultLanguage].filters
            //     ),
            // },
          ]}
        />
        <Modal
          handleClose={this.handleCountDetailsClose}
          show={this.state.showCountDetailsModal}
          title={`${this.state.countDetailsTitle} (${this.state.countDetailsTotalRecords})`}
          size="xl"
        >
          <div className="card-body">
            <Table
              data={this.state.countDetailsData}
              isSearch
              page={this.state.countDetailsPage}
              limit={this.state.countDetailsLimit}
              search_text={this.state.countDetailsSearchText}
              handleSearch={this.handleCountDetailsSearch}
              addSearchButton
              searching={this.state.searchingCountDetails}
              handlePressSearch={this.handleCountDetailsRemoteSearch}
              totalPageCount={this.state.countDetailsTotalPageCount}
              totalRecords={this.state.countDetailsTotalRecords}
              isLoading={this.state.isLoadingCountDetails}
              handlePagination={this.handleCountDetailsPagination}
              headers={this.returnCountDetailsHeaders()}
              rowPress={(item) =>
                this.handleShowModal("showModal", item.donorNumber, item)
              }
              actions={[]}
            />
          </div>
        </Modal>
        <Modal
          handleClose={this.handleCloseModal.bind(this, "showModal")}
          show={this.state.showModal}
          title={this.state.modalTitle}
          showHeaderBottomBorder={false}
          size="lg"
          backdrop="static"
        >
          {this.state?.selectedData?._id ? (
            <Tabs
              options={[
                {
                  title: language[this.props.defaultLanguage].donor_information,
                  data: (
                    <NewDonor
                      handleCloseModal={this.handleCloseModal.bind(
                        this,
                        "showModal",
                      )}
                      getData={this.getData.bind(this)}
                      {...this.state.selectedData}
                      route={this.props.route}
                    />
                  ),
                },
                {
                  title:
                    language[this.props.defaultLanguage]
                      .pre_donation_assessment,
                  data: (
                    <div className="card-body">
                      <PreAssessment donorId={this.state.selectedData._id} />
                    </div>
                  ),
                },
                {
                  title: language[this.props.defaultLanguage].blood_donation,
                  data: (
                    <div className="card-body">
                      <BloodCollection donorId={this.state.selectedData._id} />
                    </div>
                  ),
                },
              ]}
            />
          ) : (
            <NewDonor
              route="/dashboard"
              handleCloseModal={this.handleCloseModal.bind(this, "showModal")}
              getData={this.getData.bind(this)}
              {...this.state.selectedData}
            />
          )}
        </Modal>
        <Modal
          handleClose={this.handleCloseModal.bind(this, "showBlockModal")}
          show={this.state.showBlockModal}
          title={this.state.modalTitle}
        >
          <Block
            handleCloseModal={this.handleCloseModal.bind(
              this,
              "showBlockModal",
            )}
            getData={this.getData.bind(this)}
            donor={this.state.selectedData}
          />
        </Modal>
        <Modal
          handleClose={this.handleCloseModal.bind(this, "showUnblockModal")}
          show={this.state.showUnblockModal}
          title={this.state.modalTitle}
          backdrop={false}
          dialogClassName="modal-dialog-centered modal-float-sm"
        >
          <UnBlock
            handleCloseModal={this.handleCloseModal.bind(
              this,
              "showUnblockModal",
            )}
            getData={this.getData.bind(this)}
            donor={this.state.selectedData}
          />
        </Modal>
        <Modal
          handleClose={this.handleCloseModal.bind(this, "showDeleteModal")}
          show={this.state.showDeleteModal}
          title={this.state.modalTitle}
        >
          <DeleteModal
            handleCloseModal={this.handleCloseModal.bind(
              this,
              "showDeleteModal",
            )}
            error={this.state.error.delete_password}
            value={this.state.delete_value}
            onDelete={this.onDelete.bind(this)}
            onChange={(e) => this.onChangeText("delete_value", e)}
            isDeleting={this.state.isDeleting}
            name={this.state.selectedData.email}
            getData={this.getData.bind(this)}
          />
        </Modal>
        <Modal
          handleClose={this.handleCloseModal.bind(this, "filtersModal")}
          show={this.state.filtersModal}
          title={this.state.modalTitle}
          size="lg"
        >
          <div className="card-body">
            <div className="row">
              <DonorFilters
                fetchData={(params) => this.fetchData(true, params)}
                handleCloseModal={this.handleCloseModal.bind(
                  this,
                  "filtersModal",
                )}
              />
            </div>
          </div>
        </Modal>
        <CSVLink
          ref={this.csvDownload}
          filename={"Requests" + new Date().getTime()}
          data={this.state.csvData}
        ></CSVLink>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(Donors);
